import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  personImage: {
    width: 85,
    height: 85,
    objectFit: 'cover',
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 10
  },
  agreementHeading: {
    fontSize: 20,
    fontWeight: 500,
    textAlign: 'center',
    position: 'relative',
    textShadow: `0px 3px 6px ${theme.palette.grey[100]}`,
    color: theme.palette.primary.dark,
    '&::after': {
      content: "''",
      display: 'block',
      width: '25%',
      height: '2px',
      background: theme.palette.grey[900],
      right: '3%',
      top: '50%',
      position: 'absolute',
    },
    '&::before': {
      content: "''",
      display: 'block',
      width: '25%',
      height: '2px',
      background: theme.palette.grey[900],
      left: '3%',
      top: '50%',
      position: 'absolute',
    },
    [theme.breakpoints.down('md')]: {
      '&::before': {
        width: '90px',
      },
      '&::after': {
        width: '90px',
      }
    },
    '@media (max-width: 410px)': {
      '&::before': {
        width: '65px',
      },
      '&::after': {
        width: '65px',
      }
    }
  },
  btnWrapper: {
    '& button': {
      width: '100%'
    }
  },
  checkboxErrorText: {
    color: theme.palette.error.main,
    fontSize: 12
  },
}));
